// extracted by mini-css-extract-plugin
module.exports = {"game":"HotspotGame_game__2KG79","game__title":"HotspotGame_game__title__2_mK_","game__description":"HotspotGame_game__description__2dmPh"};